// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { initReactI18next } from 'react-i18next';

import en from './en/translation.json';
import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

const resources = {
  en,
};

i18n
  .use(Backend)
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    keySeparator: '.',
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: { useSuspense: false },
    compatibilityJSON: 'v3',
  });

const t = i18n.t.bind(i18n);
export { t };

export default i18n;
